"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ToolbarButton = _interopRequireDefault(require("./ToolbarButton/ToolbarButton"));

var _ToolbarPageNav = _interopRequireDefault(require("./ToolbarPageNav/ToolbarPageNav"));

var _ToolbarZoomNav = _interopRequireDefault(require("./ToolbarZoomNav/ToolbarZoomNav"));

var _reactTimeout = _interopRequireDefault(require("react-timeout"));

var _DownloadIcon = _interopRequireDefault(require("../../../icons/standard-icons/DownloadIcon"));

var _PrintIcon = _interopRequireDefault(require("../../../icons/standard-icons/PrintIcon"));

var _ExpandIcon = _interopRequireDefault(require("../../../icons/standard-icons/ExpandIcon"));

var _ContractIcon = _interopRequireDefault(require("../../../icons/standard-icons/ContractIcon"));

var _Modal = _interopRequireDefault(require("../../../modal/Modal"));

var _ModalCloseButton = _interopRequireDefault(require("../../../modal/ModalCloseButton"));

var _H = _interopRequireDefault(require("../../../typography/headings/H5"));

var _Button = _interopRequireDefault(require("../../../buttons/Button/Button"));

var _styles = require("./styles");

var _hooks = require("./hooks");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Toolbar = ({
  rootRef,
  blob,
  options,
  currentPage,
  numPages,
  onPageNumberChange,
  zoom,
  onZoomChange,
  fullScreen,
  onToggleFullScreen,
  download,
  isMobile,
  setTimeout
}) => {
  const {
    printDocument,
    showPrintUnsupportedModal,
    closePrintUnsupportedModal,
    downloadFromModal,
    toggleFullscreen
  } = (0, _hooks.useToolbar)({
    rootRef,
    download,
    blob,
    fullScreen,
    onToggleFullScreen,
    setTimeout
  });
  const {
    enableDownload,
    enablePageNav,
    enableZoom,
    enablePrint,
    enableFullscreen,
    toolbarPosition,
    toolbarButtons,
    minZoom,
    maxZoom,
    zoomIncrement,
    printingNotSupportedMessage
  } = options;

  if (!enableDownload && !enablePageNav && !enableZoom && !enablePrint && !enableFullscreen) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ToolbarForm, {
    className: "document-toolbar",
    toolbarPosition: toolbarPosition,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ToolbarFormInner, {
      className: "document-toolbar__bar",
      options: options,
      children: [enableDownload && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolbarButton.default, {
        className: "toolbar-button",
        tooltip: "Download",
        onClick: download,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DownloadIcon.default, {})
      }), enableDownload && (enablePageNav || enableZoom && !isMobile || enablePrint && !isMobile || enableFullscreen) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ToolbarSeparator, {
        className: "toolbar-separator",
        options: options
      }), enablePageNav && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolbarPageNav.default, {
        options: options,
        tooltip: "Click to jump to a page",
        currentPage: currentPage,
        numPages: numPages,
        onPageNumberChange: onPageNumberChange
      }), enablePageNav && (enableZoom && !isMobile || enablePrint && !isMobile || enableFullscreen) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ToolbarSeparator, {
        className: "toolbar-separator",
        options: options
      }), enableZoom && !isMobile && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolbarZoomNav.default, {
        options: options,
        zoom: zoom,
        onZoomChange: onZoomChange,
        minZoom: minZoom,
        maxZoom: maxZoom,
        zoomIncrement: zoomIncrement
      }), enableZoom && !isMobile && (enablePrint && !isMobile || enableFullscreen) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ToolbarSeparator, {
        className: "toolbar-separator",
        options: options
      }), enablePrint && !isMobile && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolbarButton.default, {
        className: "toolbar-button",
        tooltip: "Print",
        onClick: printDocument,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PrintIcon.default, {})
      }), enablePrint && !isMobile && enableFullscreen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ToolbarSeparator, {
        className: "toolbar-separator",
        options: options
      }), enableFullscreen && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ToolbarButton.default, {
        className: "toolbar-button",
        tooltip: fullScreen ? 'Exit full screen' : 'View full screen',
        onClick: toggleFullscreen,
        children: [!fullScreen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandIcon.default, {}), fullScreen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContractIcon.default, {})]
      }), toolbarButtons && toolbarButtons.map((Button, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {}, index)), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default, {
        isOpen: showPrintUnsupportedModal,
        onBackgroundClick: closePrintUnsupportedModal,
        onEscapeKeydown: closePrintUnsupportedModal,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ModalHeader, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_H.default, {
            children: "Unable to print document"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalCloseButton.default, {
            onClick: closePrintUnsupportedModal
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ModalBody, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: printingNotSupportedMessage
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ModalFooter, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            primary: true,
            small: true,
            onClick: downloadFromModal,
            children: "Download"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            small: true,
            onClick: closePrintUnsupportedModal,
            children: "Close"
          })]
        })]
      })]
    })
  });
};

Toolbar.propTypes = {
  rootRef: _propTypes.default.object.isRequired,
  blob: _propTypes.default.object.isRequired,
  options: _propTypes.default.object,
  currentPage: _propTypes.default.number,
  numPages: _propTypes.default.number.isRequired,
  onPageNumberChange: _propTypes.default.func,
  zoom: _propTypes.default.number,
  onZoomChange: _propTypes.default.func,
  fullscreen: _propTypes.default.bool,
  onToggleFullScreen: _propTypes.default.func,
  download: _propTypes.default.func,
  isMobile: _propTypes.default.bool,
  setTimeout: _propTypes.default.func.isRequired
};
Toolbar.defaultProps = {
  options: {},
  currentPage: 1,
  onPageNumberChange: () => {},
  zoom: 100,
  onZoomChange: () => {},
  fullscreen: false,
  onToggleFullScreen: () => {},
  download: () => {},
  isMobile: false
};

var _default = (0, _reactTimeout.default)(Toolbar);

exports.default = _default;